const VERSION = '2.0.7p'
export default VERSION
